var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    rx: 5.317,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.368 6.382 2.298 2.262c.126.123.238.255.334.395.064-.093.135-.183.213-.27l.12-.125 2.299-2.262a.916.916 0 0 1 1.27-.001c.325.315.35.811.077 1.155l-.075.082-2.299 2.263a.86.86 0 0 0-.075 1.155l.075.083 2.3 2.263c.35.342.35.896-.002 1.237a.909.909 0 0 1-.635.256.912.912 0 0 1-.544-.178l-.092-.079-2.299-2.262A2.641 2.641 0 0 1 10 11.96a2.62 2.62 0 0 1-.333.395l-2.299 2.262a.908.908 0 0 1-.636.257.909.909 0 0 1-.635-.256.859.859 0 0 1-.001-1.237l2.3-2.263a.86.86 0 0 0-.001-1.238l-2.3-2.263a.859.859 0 0 1 .002-1.237.916.916 0 0 1 1.271 0z",
    fill: "#495171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.c39599297cc2b55b36f626e7d50ebd6c.svg";
export { ForwardRef as ReactComponent };